// extracted by mini-css-extract-plugin
export default {"container":"nTSZffg7TazzMPzedLgm","img":"Ya0HilZmZUhk4xUNPzrf","emoji":"urAGDmy5IHeOCJ3eYjB4"};